export const apps = [
  {
    appIcon: "/images/app-icons/card-pouch.png",
    link: "https://apps.apple.com/th/app/card-pouch/id1598972460",
  },
  {
    appIcon: "/images/app-icons/matrix-pocket.png",
    link: "https://apps.apple.com/th/app/matrix-pocket/id1598796806",
  },
]
